import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IDanhSachLuanVanUpdateLockStatusRequest } from "../../../model/request/xet-khoa-luan/IDanhSachLuanVanUpdateLockStatusRequest";
import { IDanhSachThiTotNghiepUpdateLockStatusRequest } from "../../../model/request/xet-khoa-luan/IDanhSachThiTotNghiepUpdateLockStatusRequest";
import { IXetKhoaLuanRequest } from "../../../model/request/xet-khoa-luan/IXetKhoaLuanRequest";
import { IXetKhoaLuanSelectByLopRequest } from "../../../model/request/xet-khoa-luan/IXetKhoaLuanSelectByLopRequest";
import { IXetKhoaLuanResponse } from "../../../model/response/xet-khoa-luan/IXetKhoaLuanResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IXetKhoaLuanActionTypeBase<T> {
    request: IXetKhoaLuanSelectByLopRequest;
    data: T;
}

export const eXetKhoaLuanActionsObj = {
    XET_START: {} as IXetKhoaLuanActionTypeBase<IXetKhoaLuanRequest>,
    XET_SUCCESS: {} as IXetKhoaLuanActionTypeBase<undefined>,
    XET_ERROR: {} as IXetKhoaLuanActionTypeBase<string>,

    FOCUSED_TAB_CHANGE: {} as "luan-van" | "thi-tot-nghiep" | "khong-du-dieu-kien",

    INI_START: {} as IXetKhoaLuanSelectByLopRequest,

    LOAD_START: {} as IXetKhoaLuanActionTypeBase<IXetKhoaLuanSelectByLopRequest | undefined>,
    LOAD_SUCCESS: {} as IXetKhoaLuanActionTypeBase<IXetKhoaLuanResponse>,
    LOAD_ERROR: {} as IXetKhoaLuanActionTypeBase<string>,

    UPDATE_LOCK_STATUS_LUAN_VAN_START: {} as IXetKhoaLuanActionTypeBase<IDanhSachLuanVanUpdateLockStatusRequest>,
    UPDATE_LOCK_STATUS_LUAN_VAN_SUCCESS: {} as IXetKhoaLuanActionTypeBase<undefined>,
    UPDATE_LOCK_STATUS_LUAN_VAN_ERROR: {} as IXetKhoaLuanActionTypeBase<string>,

    UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_START: {} as IXetKhoaLuanActionTypeBase<IDanhSachThiTotNghiepUpdateLockStatusRequest>,
    UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_SUCCESS: {} as IXetKhoaLuanActionTypeBase<undefined>,
    UPDATE_LOCK_STATUS_THI_TOT_NGHIEP_ERROR: {} as IXetKhoaLuanActionTypeBase<string>,

    CHUYEN_LUAN_VAN_START: {} as IXetKhoaLuanActionTypeBase<IIdsRequest>,
    CHUYEN_LUAN_VAN_SUCCESS: {} as IXetKhoaLuanActionTypeBase<undefined>,
    CHUYEN_LUAN_VAN_ERROR: {} as IXetKhoaLuanActionTypeBase<string>,

    CHUYEN_THI_TOT_NGHIEP_START: {} as IXetKhoaLuanActionTypeBase<IIdsRequest>,
    CHUYEN_THI_TOT_NGHIEP_SUCCESS: {} as IXetKhoaLuanActionTypeBase<undefined>,
    CHUYEN_THI_TOT_NGHIEP_ERROR: {} as IXetKhoaLuanActionTypeBase<string>,

    CHANGER_SELECTED_IDS_LUAN_VAN: {} as  IXetKhoaLuanActionTypeBase<number[]>,
    CHANGER_SELECTED_IDS_THI_TOT_NGHIEP: {} as IXetKhoaLuanActionTypeBase<number[]>,


    SHOW_THAM_SO_MODAL: undefined,
    CLOSE_THAM_SO_MODAL: undefined,

    CLOSE_PROCESSING_MODAL: undefined,
}

export const eXetKhoaLuanActionIds = generateActionTypeIds(eXetKhoaLuanActionsObj, "XET_KHOA_LUAN");
export type IXetKhoaLuanActionTypes = IGenericActionType<typeof eXetKhoaLuanActionsObj, "XET_KHOA_LUAN">;